import { EditCalendar, Event } from "@mui/icons-material";
import { ListSubheader, Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { GqlPlannerVisitStatus } from "~/__generated__";
import GaiaMenuItem from "~/modules/app/components/GaiaMenuItem";

export default function PlannerMenu() {
    const { t } = useTranslation("planner");
    return (
        <>
            <ListSubheader sx={{ backgroundColor: "background.default" }}>
                <Typography variant="overline" sx={{ textTransform: "none" }}>
                    {t("plannerMenu.header")}
                </Typography>
            </ListSubheader>

            <GaiaMenuItem
                to={`/planner/${format(new Date(), "yyyy-MM-dd")}`}
                label={t("plannerMenu.itemPlanner")}
                icon={<EditCalendar />}
                matchExact
            />

            <GaiaMenuItem
                to={`/visits?plannerVisitStatus=${GqlPlannerVisitStatus.AwaitingApproval}`}
                label={t("plannerMenu.itemPlanned")}
                icon={<Event />}
                matchExact
            />
        </>
    );
}
